import _ from 'lodash';
import axios from 'axios';
import url from 'url';

/**
 * @returns {Promise<string>}
 */
export default async ({
  domain,
  dialPlan,
  responder,
  toUser,
  user,
}) => {
  const token = global.localStorage.getItem('ns_t');

  if (!token) {
    throw Error('getDialRule function requires a netsapiens access_token from browser local storage');
  }

  if (!domain) {
    throw Error('Function param "domain" required');
  }

  if (!dialPlan) {
    throw Error('Function param "dialPlan" required');
  }

  if (!responder) {
    throw Error('Function param "responder" required');
  }

  if (!toUser) {
    throw Error('Function param "toUser" required');
  }

  if (!user) {
    throw Error('Function param "user" required');
  }

  const { protocol, hostname } = url.parse(global.location.href);

  const { data } = await axios.request({
    method: 'get',
    withCredentials: true,
    url: `${protocol}//${hostname}/ns-api/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      object: 'dialrule',
      action: 'read',
      user,
      domain,
      dialplan: dialPlan,
      responder,
      to_user: toUser,
      format: 'json',
    },
  });

  return _.get(data, ['0']);
};
